import { configureStore } from "@reduxjs/toolkit";
import createSession from '../reducers/SessionSlice'

export const Store = configureStore({
    reducer:{
        currentSession:createSession,
    }
}) 